import {
  // ApolloClient,
  // createHttpLink,
  gql,
  // InMemoryCache,
} from "@apollo/client"


export class PostsUtils {
  graphql_query = gql`
    query GET_POSTS($authorId: Int!, $first: Int, $after: String) {
      posts(
        where: { author: $authorId, orderby: { field: DATE, order: DESC } }
        first: $first
        after: $after
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            authorId
            title
            excerpt
            uri
            link
            date
            featuredImage {
              node {
                link
                guid
                mediaItemUrl
                srcSet
                sizes
              }
            }
          }
        }
      }
    }
  `

  constructor(args = {}, sources = null, currentPage = -1, node = "posts") {
    this.args = {}
    this.categoryArgs = args["categories"];
    this.hasCategories = this.categoryArgs &&
      Object.keys(this.categoryArgs).length > 0 &&
      this.categoryArgs.constructor === Object;
    if (args["authorId"])
        this.args['author'] = args["authorId"];
    if (args["tags"]) this.args["tags"] = args["tags"];
    this.node = node;
    this.data = [];
    this.pageSize = 20;
    this.exclude = [];
    this.currentPage = currentPage || 0;
    this.hasNextPage = false;
    this.pages = [];
    this.sources = sources || [
      {
        offset: 0,
        offsetHistory: [],
        site: "www",
        url: "https://admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "impact",
        url: "https://impact-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "cybersecurity",
        url: "https://cybersecurity-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "ischool",
        url: "https://ischool-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "openinnovation",
        url: "https://openinnovation-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "smartworking",
        url: "https://smartworking-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "smartmoney",
        url: "https://smartmoney-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "sportup",
        url: "https://sportup-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "thefoodmakers",
        url: "https://thefoodmakers-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "thenexttech",
        url: "https://thenexttech-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "valoreresponsabile",
        url: "https://valoreresponsabile-admin.startupitalia.eu/wp-json/wp/v2/",
      },
      {
        offset: 0,
        offsetHistory: [],
        site: "life",
        url: "https://life-admin.startupitalia.eu/wp-json/wp/v2/",
      },
    ]
  }

  serialize = function (obj) {
    var str = []
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
      }
    return str.join("&")
  }

  updateOffests(direction) {
    this.data.forEach((record) => {
      var index = this.sources.findIndex((p) => p.site === record.site)
      this.sources[index]["offset"] += 1
    })
  }

  getPosts(direction = "next") {
    this.data = []

    const requestOptions = {
      credentials: "omit",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
      method: "GET",
      mode: "cors",
    }
    if (direction === "next") this.currentPage += 1
    else this.currentPage -= 1

    var promises = []
    for (const [, obj] of this.sources.entries()) {
      var _args = { ...this.args };
      if (this.hasCategories) {
        if (this.categoryArgs[obj["site"]])
          _args["categories"] = this.categoryArgs[obj["site"]];
        else
          _args["categories"] = 0;
      }

      var url = `${obj["url"]}${this.node}?${this.serialize(_args)}`;
      // console.log('url', url)
      var offset;
      if (obj['offsetHistory'][this.currentPage] !== void 0)
        offset = obj["offsetHistory"][this.currentPage]
      else {
        offset = obj["offset"]
        obj["offsetHistory"][this.currentPage] = offset
      }

      url = url + `&orderby=date&per_page=${this.pageSize}&offset=${offset}`

      if (this.exclude.length) {
        url = url + `&exclude=${this.exclude}`
      }
      if (url.includes('/admin.start'))
        console.log("url_offset", url, obj['offset'])
      var promise = fetch(url, requestOptions)
      promises.push(promise)
    }

    const result = new Promise((resolve, reject) => {
      Promise.all(promises.map((p) => p.catch((e) => e)))
        .then((results) => {
          var _promises = []
          for (const [, result] of results.entries()) {
            _promises.push(result.json())
          }
          Promise.all(_promises.map((p) => p.catch((e) => e))).then(
            (_results) => {
              var posts
              for (const [i, data] of _results.entries()) {
                posts = data
                posts = posts.map((item) => ({
                  ...item,
                  site: this.sources[i]["site"],
                }))
                this.data.push(...posts)
              }
              this.data.sort(function (a, b) {
                var keyA = new Date(a.date),
                  keyB = new Date(b.date)

                if (keyA > keyB) return -1
                if (keyA < keyB) return 1

                return 0
              })
              this.hasNextPage = this.data.length >= this.pageSize;
              this.data =  this.data.slice(0, 20);
              this.updateOffests(direction)

              resolve({
                data: this.data,
                sources: this.sources,
                currentPage: this.currentPage,
                hasNextPage: this.hasNextPage,
              })
            }
          )
        })
        .catch((e) => console.log("PromiseAll error", e))
    })
    return result
  }
}
